import axios from "axios";
import { api } from "./helper";
import store from "../../store/store"
import { v4 as uuidv4 } from "uuid";

function prepareRequest(data) {
  return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function GetSubrogationDocs(subrogationId, participantId, courtCaseId, enforcementId) {
  return client.post(
    "Docs/GetSubrogationDocs",
    prepareRequest({
      SubrogationId: subrogationId,
      ParticipantId: participantId,
      CourtCaseId: courtCaseId,
      EnforcementId: enforcementId,
    })
  );
}

function GetAllDocs(subrogationId) {
  return client.post(
    "Docs/GetAllDocs",
    prepareRequest({ SubrogationId: subrogationId })
  );
}



export {
  GetSubrogationDocs,
  GetAllDocs
};
